import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllSubjectsRequest } from "../modules/admin-modules/subjects/Actions";

export const useSuperAdminSubjectFilter = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const userRole = Array.isArray(user?.role) ? user.role[0]?.name : null;
  const isSuperAdmin = userRole === "Super Admin";
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);

  useEffect(() => {
    if (isSuperAdmin) {
      dispatch(getAllSubjectsRequest());
    }
  }, [isSuperAdmin, dispatch]);

  const subjectQuery = selectedSubjectId ? { subject_id: selectedSubjectId } : {};
  const canFetch = Boolean(userRole) && (!isSuperAdmin || Boolean(selectedSubjectId));

  return {
    userRole,
    isSuperAdmin,
    selectedSubjectId,
    setSelectedSubjectId,
    subjectQuery,
    canFetch,
  };
};
